/* eslint-disable */
class Accordion {
	constructor (element) {

        this.element = element
        this.button = element.querySelector('.accordion-button')
        this.content = element.querySelector('.accordion-content')
		this.isOpen = false
	}

	open () {
		this.isOpen = true
		this.render()
	}

	close () {
		this.isOpen = false
		this.render()
	}

	render () {
		if(this.content == null) return;
		if (this.isOpen) {
            this.content.style.maxHeight = this.content.scrollHeight + "px";

		} else {

            this.content.style.maxHeight = null;

		}
    }   
}
export {Accordion}
